import { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Icon, IconButton } from "@evertrue/et-components";
import { TodoShapePropTypes } from "apps/todo/todo-prop-types";
import get from "lodash.get";

class TodoInfoArea extends Component {
  static propTypes = {
    todo: TodoShapePropTypes,
    deleteTodo: PropTypes.func,
    editButtonClicked: PropTypes.func,
    fetchReminder: PropTypes.func,
    reminders: PropTypes.array,
  };

  static defaultProps = {
    todo: {},
    deleteTodo: () => {},
    editButtonClicked: () => {},
    reminders: [],
    fetchReminder: () => {},
  };

  componentDidMount() {
    this.props.fetchReminder(this.props.todo.id);
  }

  render() {
    const { due_date, id, description } = this.props.todo;
    const due_month_date_day = due_date ? moment(due_date).format("MMM DD ddd") : "No DueDate";
    const reminderTime = get(this.props.reminders, "[0].remind_at", null);
    const reminder_month_date_day = reminderTime ? moment(reminderTime).format("MMM DD hh:mma") : "No Reminder";

    return (
      <div className="todo-item--info-wrapper">
        <div className="todo-item--info-text-holder">
          <div className="todo-item--info-area-date-holder">
            <div className="todo-item--info-area-duedate">
              <Icon icon="event" />
              {due_month_date_day}
            </div>
            <div className="todo-item--info-area-reminder">
              <Icon icon="alarm" />
              {reminder_month_date_day}
            </div>
          </div>
          <div className="todo-item--info-notes-image-holder">
            <Icon icon="notes" />
          </div>
          <div className="todo-item--info-area-description">{description}</div>
          <div className="todo-info--action-section">
            <IconButton
              title="delete to do"
              className="todo-info--delete-button"
              icon="delete"
              onClick={() => this.props.deleteTodo(id)}
            />
            <IconButton
              title="edit to do"
              className="todo-info--edit-button"
              icon="edit"
              onClick={() => this.props.editButtonClicked(id)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default TodoInfoArea;
